import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SkladisteService {

  constructor(private _http: HttpClient) { }

  dohvatiSkladista_Pekar_i_Tomo(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_skladista_pekar_i_tomo', a)
      .pipe(map((res: any) => res));
  }

  stanjeSkladista(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_stanje_skladista', a)
      .pipe(map((res: any) => res));
  }

}
